import { render, staticRenderFns } from "./DonatorEditComp.vue?vue&type=template&id=61d5cb48"
import script from "./DonatorEditComp.vue?vue&type=script&lang=js"
export * from "./DonatorEditComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports